import { useDataset } from '@infinex/user';

export function useIsPatron(): boolean {
  const { data } = useDataset('user');
  return data?.status.isPatron ?? false;
}
